import { TeacherIcon } from 'morpheus-ui';
import { Icon } from '../../atoms/Icon';
import { Tag, TagProps } from '../../atoms/Tag';
import { Typography } from '../Typography';

type EventTag = {
  label: string;
  variant: TagProps['variant'];
};

interface iEventItemProps {
  startTime?: string;
  itsHappeningNow?: boolean;
  tags: EventTag[];
  title: string;
  teacherName?: string;
  showCheckIcon?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

function EventItem({
  startTime,
  teacherName,
  title,
  itsHappeningNow,
  tags,
  showCheckIcon = false,
  disabled = false,
  onClick,
}: iEventItemProps) {
  return (
    <>
      <li
        className={`rounded flex gap-4 !rounded-md py-1 px-2 ${
          itsHappeningNow ? 'bg-color-lighter' : ''
        } ${disabled ? 'opacity-50' : ''} ${
          onClick ? 'hover:cursor-pointer hover:bg-color-lighter' : ''
        }`}
        onClick={onClick}
      >
        <div className='min-w-[70px] border-r-thin border-r-button-color-tertiary-default pr-4'>
          <Typography
            type='title'
            size='h4'
            className='flex h-full items-center justify-center'
          >
            {startTime}
          </Typography>
        </div>
        <div className='flex w-full flex-col gap-xs'>
          <div className='flex items-center gap-1'>
            {tags.map((tag, index) => (
              <Tag className={`text-sm`} variant={tag.variant} key={index}>
                {tag.label}
              </Tag>
            ))}
            {showCheckIcon && (
              <div className='ml-auto flex items-center'>
                <Icon
                  Icon={'check_circle'}
                  type='material'
                  variant='fill'
                  className='filled mx-auto text-[18px] text-feedback-color-success-pure'
                />
              </div>
            )}
          </div>
          <Typography type='title' size='h5' className='line-clamp-2'>
            {title}
          </Typography>
          {teacherName && (
            <Typography
              size='small'
              className='line-clamp-1 flex gap-1 text-mono-color-darker'
            >
              <Icon Icon={TeacherIcon} type='svg' className='w-4' />
              Prof. {teacherName}
            </Typography>
          )}
        </div>
      </li>
      <span className='my-3 border-b-hairline border-b-mono-color-light last:m-0 last:border-none'></span>
    </>
  );
}

export { EventItem };
export type { EventTag };
